import {
  homepageImageUrl,
  type HomepageHeroContent,
} from "@/data/homepageContent";

type HeroSectionProps = {
  content: HomepageHeroContent;
};

export function HeroSection({ content }: HeroSectionProps) {
  return (
    <div className="panel-inner">
      <div className="nb-logo">
        <img
          src={homepageImageUrl(content.logo)}
          alt={content.logo.alt}
        />
      </div>

      <div className="left-meta">{content.side_label}</div>
      <div className="copyright-meta">{content.copyright_label}</div>

      <div className="hero-copy">
        <p className="hero-kicker" data-reveal>
          {content.kicker}
        </p>
        <h1
          className="hero-title"
          aria-label={[
            content.line_one,
            content.line_two,
            content.moving_line,
            content.ghost_line,
            content.accent_line,
          ].join(" ")}
        >
          <span className="hero-line" data-reveal>
            {content.line_one}
          </span>
          <span
            className="hero-line"
            data-reveal
            style={{ ["--reveal-delay" as string]: "80ms" }}
          >
            {content.line_two}
          </span>
          <span
            className="hero-line hero-line--move"
            data-reveal
            style={{ ["--reveal-delay" as string]: "160ms" }}
          >
            <span className="hero-line-move-inner">{content.moving_line}</span>
          </span>
          <span
            className="hero-line hero-line--ghost"
            data-reveal
            style={{ ["--reveal-delay" as string]: "240ms" }}
          >
            {content.ghost_line}
          </span>
          <span
            className="hero-line hero-line--accent"
            data-reveal
            style={{ ["--reveal-delay" as string]: "320ms" }}
          >
            {content.accent_line}
          </span>
        </h1>
      </div>

      <p
        className="hero-paragraph"
        data-reveal
        style={{ ["--reveal-delay" as string]: "420ms" }}
      >
        {content.paragraph}
      </p>

      <a
        className="continuity-mark"
        href={content.continuity_href}
        aria-label={content.continuity_label}
        data-magnetic
      >
        <img
          src={homepageImageUrl(content.continuity_logo)}
          alt={content.continuity_logo.alt}
        />
      </a>
    </div>
  );
}
